export const clearStorage = (): void => {
  localStorage.removeItem('jwtToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('currentUser');
  localStorage.removeItem('userPreferences');
  localStorage.removeItem('userPreferences_backendFetched');
};

export const navigateToLoginPage = (): void => {
  window.location.href = `${window.location.origin}/login`;
};
